<script>
import _ from "lodash";
import baseMixins from '@/plans/ZOOM_MEETING/config/base';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { BASE_PLAN_SUB_TYPES, planTypes, maxBizAndBizPlusLicenseCount } from '@/common/constants';
import { isAutoAddableAndAutoAddPlanSelected } from '@/plans/ZOOM_MEETING/common/utils';
import { getPlanTypeName } from '@/common/service/parse/parse-product-name';

export default {
  mixins: [baseMixins],
  data() {
    return {
      showPlanDetail: true,
      previousQuantity: 1,
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'planMapFlat', 'boughtPlans', 'plansofBizBundle']),
    ...mapState({
      updateBasePlan: state => state.Product.updateBasePlan,
    }),
    showExploreLink() {
      if (this.$context.is.edu) return false;
      return this.form.selectedNumber < maxBizAndBizPlusLicenseCount && this.canSwitchCategory;
    },
    licenseAlertDesc() {
      if (this.isAutoAdd) {
        return this.$t('billing.zone.alert_title', [
          this.$t(getPlanTypeName(this.$context.type)),
          this.$t(this.boughtMeetingPlan?.planNameKey),
        ]);
      }
      return this.mx_defLicenseAlertDesc;
    },
    canSwitchCategory() {
      return !this.boughtPlans.find(item => (item.type === planTypes.ZOOM_ONE_BUNDLE || item.type === planTypes.ZOOM_UNITED));
    },
    maxHost() {
      if (this.isAutoAdd) {
        return 999;
      }

      const max = this.formPlan ? this.formPlan.max : 99;

      if (this.form.category === BASE_PLAN_SUB_TYPES.BIZ) {
        return this.previousQuantity > max ? this.previousQuantity : max;
      }

      return max;
    },
    isNormalCase() {
      return !this.plansofBizBundle.boughtBizPlusPlan.length;
    },
    boughtMeetingPlan() {
      return this.boughtPlans.find(item => item.type === planTypes.ZOOM_MEETING);
    },
    // auto add to cart
    isAutoAdd() {
      return isAutoAddableAndAutoAddPlanSelected() && !!this.boughtMeetingPlan
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlan', 'setBasicConfig', 'setUpdateBasePlan']),
    ...mapActions(['switchSelectPlanAction']),
    async updateFormForInit() {
      const meetingPlan = _.find(this.getSelectedPlans, (item) => item.type === planTypes.ZOOM_MEETING);
      const bizPlan = _.chain(this.zonePlanGroupByCategory)
        .get([BASE_PLAN_SUB_TYPES.BIZ])
        .find((p) => p.billing_cycle === this.form.billingCycle)
        .value();

      // update selected number
      // CASE one purchased 10 addon plan, init pro category, set quantity to 10
      // CASE two purchase 5 addon plan, init pro category, set quantity to 5
      if (this.minHost > this.form.selectedNumber) {
        this.form.selectedNumber = this.minHost;
      }

      this.previousQuantity = this.form.selectedNumber;

      const quantity = this.form.selectedNumber;
      const category = this.form.category;

      // switch pro to biz
      if (category === BASE_PLAN_SUB_TYPES.PRO && this.form.selectedNumber > meetingPlan?.max) {
        this.form.category = BASE_PLAN_SUB_TYPES.BIZ;
        this.setBasicConfig({ bizCanDowngrade: false });
        this.oldPlanCode = bizPlan?.plan_code;
        return this.switchSelectPlanAction([meetingPlan?.plan_code, {
          ...bizPlan,
          cartInfo: {
            selected_number: quantity,
          }
        }]);
      }

      if (meetingPlan?.min < quantity && meetingPlan?.max > quantity) { // update license
        return this.updateSelectPlan({
          plan_code: meetingPlan?.plan_code,
          cartInfo: {
            selected_number: quantity,
          }
        });
      }
    },
    updateCollapsedPlan() {
      this.updateForm();
      if(this.boughtMeetingPlan){
        this.canExpand = false;
        this.isExpanded = false;
        this.setUpdateBasePlan({ update: false, from: '' });
        this.showFoldable = false;
        this.$nextTick(() => {
          this.showFoldable = true; // Avoid the appearance of the collapse animation.
        })
    }
    },
  },
  created() {
    this.showPlanDetail = this.canSwitchCategory;
    // do not switch pro to biz when it's auto-add
    if (!this.isAutoAdd) {
      // this func will switch pro to biz
      this.updateFormForInit();
    }
  },
  watch: {
    updateBasePlan: {
      handler(val) {
        val?.update && this.updateCollapsedPlan(val);
      },
    }
  }
};
</script>
